import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import VersionBox from '../../components/common/VersionBox';

class FormsModule extends React.Component {
    constructor(props) {// eslint-disable-line
        super(props);

        this.state = {
            showPreview: true,
        };
    }

    componentDidMount() {
        function getFormBuilder() {
            let scriptTag = document.createElement('script');
            scriptTag.src = window.GENESIS_FMS_SCRIPT_TAG;
            scriptTag.type = 'text/javascript';
            document.body.appendChild(scriptTag);
        }
        getFormBuilder();
        this.props.actions.getProject(this.props.match.params.projectId);
        this.props.actions.checkProjectConfig(this.props.match.params.projectId);
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
    }

    render() {
        const version = this.props.versions.select;
        const FmsSessionId = localStorage.getItem('FmsId');

        return (
            <VersionBox
                name={version.name}
                versionNumber={version.version}
                saving={version.status}
                menuSection="Forms"
                previewCssClass="app-settings_general-info"
                showPreview={this.state.showPreview}
                x
            >
                <div
                    id="mb-formbuilder-container"
                    data-api-url={window.GENESIS_FMS_API_STANDALONE}
                    data-direct-link-url={window.GENESIS_FMS_DIRECT_LINK}
                    data-start-page="dashboard"
                    data-mode="full"
                    data-session-id={FmsSessionId}
                    data-base-url={window.GENESIS_FMS_URL}
                >
                    {/* eslint-disable-line */}
                </div>
            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormsModule);
